export interface IServiceSummary {
  serviceId: string;
  service: string;
  visitCount: number;
}

export class ServiceSummary {
  serviceId: string;
  service: string;
  visitCount: number;

  constructor(data: IServiceSummary) {
    this.serviceId = data.serviceId;
    this.service = data.service;
    this.visitCount = data.visitCount;
  }
}
